import { CSSProperties, FC, PropsWithChildren } from "react"
import { cls } from "../../../../Shared/cls"
import style from "./SbtH6.module.css"

type Props = PropsWithChildren & {
	className?: string
	styles?: CSSProperties
}

/* SBT - H6 14pt semibold */
export const SbtH6: FC<Props> = ({ className, children, styles }) => {
	return (
		<h6 className={cls(style.sbtH6, className)} style={styles}>
			{children}
		</h6>
	)
}
